import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid grid-cols-12 mt-10"
}
const _hoisted_2 = { class: "col-span-12 sm:col-span-12 lg:col-span-3 xl:col-span-3" }
const _hoisted_3 = { class: "mb-5 p-3 text-center sm:text-center lg:text-start" }
const _hoisted_4 = { class: "col-span-12 sm:col-span-12 lg:col-span-9 xl:col-span-9 mt-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ImageUpload = _resolveComponent("ImageUpload")!
  const _component_EditProfile = _resolveComponent("EditProfile")!
  const _component_TeacherProfile = _resolveComponent("TeacherProfile")!
  const _component_EditPassword = _resolveComponent("EditPassword")!
  const _component_Resources = _resolveComponent("Resources")!
  const _component_AdminTheme = _resolveComponent("AdminTheme")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_Loader, {
      loader: _ctx.formLoader,
      label: "Carregando...",
      loaderType: "progress"
    }, null, 8, ["loader"]),
    (!_ctx.formLoader && _ctx.user)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.$t("labels.generic", { pt: "Dados da conta", en: "Account data" })), 1),
            _createVNode(_component_ImageUpload, { user: _ctx.user }, null, 8, ["user"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_EditProfile, { user: _ctx.user }, null, 8, ["user"]),
            (_ctx.userFromStorage.role === 'TEACHER')
              ? (_openBlock(), _createBlock(_component_TeacherProfile, {
                  key: 0,
                  user: _ctx.user.teacherProfile
                }, null, 8, ["user"]))
              : _createCommentVNode("", true),
            _createVNode(_component_EditPassword),
            (_ctx.userFromStorage.role === 'STUDENT')
              ? (_openBlock(), _createBlock(_component_Resources, { key: 1 }))
              : _createCommentVNode("", true),
            (_ctx.userFromStorage.role === 'ADMINISTRATOR')
              ? (_openBlock(), _createBlock(_component_AdminTheme, { key: 2 }))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}